import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core/'

import useCanManageApplications from 'routes/application/useCanManageApplications'
import InitiateApplicationVerification from './InitiateApplicationVerification'
import VerifyApplicationInitiation from './VerifyApplicationInitiation'

const TestConnectionStep = ({ appConfig, refetchAppConfig, completeStep }) => {
  const canCompleteStep = useCanManageApplications()
  return (
    <Box
      px={4}
      py={2}
    >
      <InitiateApplicationVerification
        appConfig={appConfig}
        refetchAppConfig={refetchAppConfig}
        readonly={!canCompleteStep}
      />
      <VerifyApplicationInitiation
        appConfig={appConfig}
        refetchAppConfig={refetchAppConfig}
        markStepComplete={completeStep}
        readonly={!canCompleteStep}
      />
    </Box>
  )
}

TestConnectionStep.propTypes = {
  appConfig: PropTypes.object,
  refetchAppConfig: PropTypes.func.isRequired,
  completeStep: PropTypes.func,
}

export default TestConnectionStep
